var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apexcharts',_vm._b({key:_vm.chartKey,attrs:{"height":_vm.height,"options":_vm.getOptions,"series":_vm.series}},'apexcharts',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }